import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../../components/Admin/AdminLayout";
import AdminHeader from "./component/AdminHeader";
import noresult from "../../images/noresult.png";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Multiselect } from "multiselect-react-dropdown";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
// ✅ Step 1: Register custom fonts for Quill
const Font = Quill.import("formats/font");
Font.whitelist = [
  "sans-serif",
  "serif",
  "monospace",
  "poppins",
  "montserrat",
  "times-new-roman",
  "georgia",
];
Quill.register(Font, true);

// ✅ Step 2: Add CSS for custom fonts
const customFontStyles = `
  .ql-editor .ql-font-poppins { font-family: 'Poppins', sans-serif; }
  .ql-editor .ql-font-montserrat { font-family: 'Montserrat', sans-serif; }
  .ql-editor .ql-font-times-new-roman { font-family: 'Times New Roman', serif; }
  .ql-editor .ql-font-georgia { font-family: 'Georgia', serif; }
`;

const styleTag = document.createElement("style");
styleTag.innerHTML = customFontStyles;
document.head.appendChild(styleTag);

const AdminBlog = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(null);
  const [blog, setBlog] = useState(null);
  const [modalMsg, setModalMsg] = useState(null);
  const [image, setImage] = useState(null);
  const [inputField, setInputField] = useState({
    title: "",
    author: "",
    description: "",
     categories: [],   // 🏷️ for multiple category selection
       travelTheme: [],  // 🌍 new field added

  trending: false,  // 🔥 for checkbox
  });
const [allCategories, setAllCategories] = useState([]);
const [allTravelThemes, setAllTravelThemes] = useState([]);

  const getAllBlog = async (elm) => {
    await axios
      .get(`api/blog/get-all-blog`)
      .then((res) => {
        let arr = res.data.data;
        console.log(res.data.data);
        setBlog(arr.reverse());
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (blog === null) {
      getAllBlog();
    }
    // eslint-disable-next-line
  }, []);
// 🔹 Fetch all categories when component mounts
useEffect(() => {
  axios
    .get("/api/category/get-all-category")
    .then((res) => {
      setAllCategories(res.data.data);
    })
    .catch((err) => console.log(err));
}, []);
// 🔹 Fetch all travel themes when component mounts
useEffect(() => {
  axios
    .get("/api/travel-theme/get-all-travel-themes")
    .then((res) => {
      setAllTravelThemes(res.data.data);
    })
    .catch((err) => console.log(err));
}, []);

  const submit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", inputField.title);
    formData.append("author", inputField.author);
    formData.append("image", image);
    formData.append("categories", JSON.stringify(inputField.categories || []));
    formData.append("travelTheme", JSON.stringify(inputField.travelTheme || []));

formData.append("trending", inputField.trending);

    formData.append("description", inputField.description);
    setLoading(true);
    axios({
      method: "POST",
      data: formData,
      withCredentials: true,
      url: `api/blog/add-blog`,
    })
      .then((res) => {
        getAllBlog();
        setTimeout(() => {
          setLoading(false);
        }, 1500);
        setInputField({
          title: "",
          author: "",
          description: "",
categories: [],
  travelTheme: [],  // ✅ added this line

  trending: false,        });
        setImage(null);
        message.success(res.data.message);
      })
      .catch((err) => {
        setTimeout(() => {
          setLoading(false);
        }, 1500);
        message.error(err.response.data.message);
        console.log(err);
      });
  };

  const deleteBlog = (id) => {
    const userConfirmed = window.confirm("Are you sure you want to delete?");
    if (userConfirmed) {
      axios({
        method: "POST",
        data: {
          id: id,
        },
        withCredentials: true,
        url: `api/blog/delete-blog`,
      })
        .then((res) => {
          getAllBlog();
          setTimeout(() => {
            setLoading(false);
          }, 1500);
          message.success(res.data.message);
        })
        .catch((err) => {
          setTimeout(() => {
            setLoading(false);
          }, 1500);
          console.log(err);
        });
    }
  };

  const hanleChange = (event, value) => {
    if (value === "image") {
      return setInputField({
        ...inputField,
        [event.target.name]: event.target.files[0],
      });
    }
    setInputField({ ...inputField, [event.target.name]: event.target.value });
  };
// 🔹 Rich Text Editor Toolbar Configuration
const modules = {
  toolbar: [
    [{ font: Font.whitelist }, { size: [] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ script: "sub" }, { script: "super" }],
    [{ header: "1" }, { header: "2" }, "blockquote", "code-block"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    ["link", "image", "video"],
    ["clean"], // remove formatting
  ],
};

const formats = [
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "script",
  "header",
  "blockquote",
  "code-block",
  "list",
  "bullet",
  "indent",
  "align",
  "link",
  "image",
  "video",
];

  return (
    <div>
      <Layout>
        <AdminHeader title="Blog" redirect="/admin-dashboard" />
        <div className=" Mon_font px-3 m-0 pb-4">
          <form
            className="row g-3 m-0 px-2 py-3 rounded border border-2"
            style={{ backgroundColor: "#f5f5f5" }}
            onSubmit={submit}
          >
            <div className="col-12 m-0 ">
              <input
                className="form-control"
                value={inputField.title}
                type="text"
                name="title"
                required
                placeholder="blog title"
                onChange={hanleChange}
                maxLength={200}
              />
            </div>
            <div className="col-6 ">
              <input
                className="form-control"
                value={inputField.author}
                type="text"
                name="author"
                required
                placeholder="author name"
                onChange={hanleChange}
                maxLength={50}
              />
            </div>
            {/* <div className="col-3 ">
              <select
                className="form-control"
                value={inputField.category}
                type="text"
                name="category"
                required
                onChange={hanleChange}
                maxLength={50}
              >
                <option value="">Select Category</option>
                <option value="Trending Blogs">Trending Blogs</option>
                <option value="Latest Blogs">Latest Blogs</option>
                <option value="Informational Blogs">Informational Blogs</option>
              </select>
            </div> */}

            {/* ✅ Multiple Category Select */}
<div className="col-4">
  <label>Select Categories</label>
  <Multiselect
    options={allCategories.map((cat) => ({ name: cat.name, id: cat._id }))}
    selectedValues={
      (inputField.categories || []).map((name) => {
        const match = allCategories.find((cat) => cat.name === name);
        return match ? { name: match.name, id: match._id } : null;
      }).filter(Boolean)
    }
    onSelect={(selectedList) =>
      setInputField({
        ...inputField,
        categories: selectedList.map((item) => item.name),
      })
    }
    onRemove={(selectedList) =>
      setInputField({
        ...inputField,
        categories: selectedList.map((item) => item.name),
      })
    }
    displayValue="name"
    showCheckbox
  />
</div>

{/* ✅ Travel Theme MultiSelect */}
<div className="col-4">
  <label>Select Travel Themes</label>
  <Multiselect
    options={allTravelThemes.map((theme) => ({ name: theme.name, id: theme._id }))}
    selectedValues={
      (inputField.travelTheme || [])
        .map((name) => {
          const match = allTravelThemes.find((theme) => theme.name === name);
          return match ? { name: match.name, id: match._id } : null;
        })
        .filter(Boolean)
    }
    onSelect={(selectedList) =>
      setInputField({
        ...inputField,
        travelTheme: selectedList.map((item) => item.name),
      })
    }
    onRemove={(selectedList) =>
      setInputField({
        ...inputField,
        travelTheme: selectedList.map((item) => item.name),
      })
    }
    displayValue="name"
    showCheckbox
  />
</div>

{/* ✅ Trending Checkbox */}
<div className="col-2 d-flex align-items-center">
  <div className="form-check">
    <input
      className="form-check-input"
      type="checkbox"
      name="trending"
      checked={inputField.trending || false}
      onChange={(e) =>
        setInputField({
          ...inputField,
          trending: e.target.checked,
        })
      }
    />
    <label className="form-check-label">Trending</label>
  </div>
</div>

            <div className="col-3 ">
              <input
                aria-label="Select Image"
                className="form-control"
                type="file"
                accept=".jpg, .jpeg, .png"
                name="image"
                required
                onChange={(e) => setImage(e.target.files[0])}
              />
            </div>
            <div className="col-12">
  <label>Description</label>
  <ReactQuill
    theme="snow"
    value={inputField.description}
    onChange={(value) =>
      setInputField({ ...inputField, description: value })
    }
    modules={modules}
    formats={formats}
    placeholder="Write your blog content here..."
    style={{ height: "300px", backgroundColor: "#fff" }}
  />
</div>

            <div className="col-2 d-flex justify-content-center align-items-center">
              <button type="submit" className="btn btn-warning w-100">
                {loading ? "Loading..." : "Save"}
              </button>
            </div>
          </form>
          {blog?.length === 0 ? (
            <div className="d-flex flex-column justify-content-center align-items-center mt-5">
              <img src={noresult} alt="" width={150} />
              <h3>No Record Found</h3>
            </div>
          ) : (
            <div className="w-100 mt-5 Mon_font overflow-auto">
              <div className="d-flex justify-content-end m-0">
                <p className="m-0 mb-3">Total Blog: {blog?.length}</p>
              </div>
              <table className="table border">
                <thead>
                  <tr>
                    <th scope="col" className="py-2 px-3 border" style={style}>
                      #
                    </th>
                    <th scope="col" className="py-2 border" style={style}>
                      Date
                    </th>
                    <th scope="col" className="py-2 px-3 border" style={style}>
                      Title
                    </th>
                    <th scope="col" className="py-2 px-3 border" style={style}>
                      Author
                    </th>
                  <th scope="col" className="py-2 px-3 border" style={style}>
  Categories
</th>
<th scope="col" className="py-2 px-3 border" style={style}>
  Travel Theme
</th> {/* ✅ NEW COLUMN */}<th scope="col" className="py-2 px-3 border" style={style}>
  Trending
</th>

                    <th
                      scope="col"
                      className="py-2 text-center border"
                      style={style}
                    >
                      image
                    </th>
                    <th
                      scope="col"
                      className="py-2 text-center border"
                      style={style}
                    >
                      Description
                    </th>
                    <th
                      scope="col"
                      className="py-2 text-center border"
                      style={style}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="table-group-divider">
                  {blog &&
                    blog.map((blog, index) => {
                      const date = new Date(blog?.date);
                      const day = date.toLocaleDateString("en-US", {
                        day: "numeric",
                      });
                      const month = date.toLocaleDateString("en-US", {
                        month: "short",
                      });
                      const year = date.toLocaleDateString("en-US", {
                        year: "numeric",
                      });
                      return (
                        <>
                          <tr>
                            <th
                              scope="row"
                              className="py-2 px-3 border"
                              style={style}
                            >
                              {index + 1}
                            </th>
                            <td className="py-2 border" style={style}>
                              {day + " " + month}
                            </td>
                            <td className="py-2 px-3 border" style={style}>
                              {blog?.title}
                            </td>
                            <td className="py-2 px-3 border" style={style}>
                              {blog?.author}
                            </td>
                            <td className="py-2 px-3 border" style={style}>
  {blog?.categories?.join(", ")}
</td>
<td className="py-2 px-3 border" style={style}>
  {blog?.travelTheme?.length > 0 ? blog.travelTheme.join(", ") : "—"}
</td> {/* ✅ Display travel themes */}
<td className="py-2 px-3 border text-center" style={style}>
  {blog?.trending ? "🔥 Yes" : "—"}
</td>

                            <td
                              className="py-2 border text-center"
                              style={style}
                            >
                              <img
                                width={90}
                                src={`/blogImages/${blog?.image}`}
                                alt=""
                              />
                            </td>
                            <td className="text-center">
                              <Link
                                to="#"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                onClick={() => {
                                  setModalMsg(blog?.description);
                                }}
                              >
                                View
                              </Link>
                              <div
                                className="modal"
                                tabIndex="-1"
                                id="exampleModal"
                              >
                                <div className="modal-dialog">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">
                                        Full Description
                                      </h5>
                                      <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={() => {
                                          setModalMsg(blog?.description);
                                        }}
                                      ></button>
                                    </div>
                                   <div
  className="text-start txt-sm"
  style={{
    overflowWrap: "break-word",
    wordWrap: "break-word",
    wordBreak: "break-word",
  }}
  dangerouslySetInnerHTML={{ __html: modalMsg }}
></div>

                                    <div className="modal-footer">
                                      <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        data-bs-dismiss="modal"
                                        onClick={() => {
                                          setModalMsg(null);
                                        }}
                                      >
                                        Close
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td className="text-center border">
                              <EditIcon
                                className="text-warning me-3"
                                onClick={() =>
                                  navigate(`/admin-edit-blog/${blog?._id}`)
                                }
                              />
                              <DeleteIcon
                                className="text-danger"
                                onClick={() => {
                                  deleteBlog(blog?._id);
                                }}
                              />
                            </td>
                          </tr>
                        </>
                      );
                    })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </Layout>
    </div>
  );
};

const style = {
  fontSize: "13px",
};

export default AdminBlog;
